export function validNumberInput(value: any): boolean {
  const floatRegex = /^-?\d*(?:\.?\d*)$/;
  return floatRegex.test(value) || value == ''
}